// 腾讯广告小游戏sdk
// import {
//     SDK
// } from '@dn-sdk/minigame';
let SDK = {}
DnSdkTool = xClass("DnSdkTool")
let instance = null
DnSdkTool.getInstance = function () {
    let self = this
    if (!instance) {
        instance = DnSdkTool.create()
    }
    return instance
}

DnSdkTool.prototype.init = function (data) {
    let self = this
    self.data = data;

    function openSdk() {
        if (self.isOpenAllReport()) {
            return true;
        }
        if (self.isConformToSource() && self.getCreateDay(self.getData().create_time) <= 30) {
            return true;
        }

        return false;
    }

    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame && openSdk()) {
        SDK = require("clover/utils/DnSdk")
        // 是否打开调试模式, 建议仅在调试期间开启
        SDK.setDebug(false);

        self.sdk = new SDK({
            // 数据源ID，数字，必填
            user_action_set_id: 1202406779,
            // 加密key，必填
            secret_key: 'afc914af3cf24ab3c49adbc274c17c15',
            // 微信小游戏APPID，wx开头，必填
            appid: 'wxd93fb8bddf971d14',
        });
        console.log("DnSdk init succ", self.sdk)
    } else {
        console.log("DnSdk init fail")
    }
}
DnSdkTool.prototype.ctor = function () {
    let self = this
    // this.init()
}

DnSdkTool.prototype.isOpenAllReport = function () {
    return window.enableWechatDnSDK == 1;
}

DnSdkTool.prototype.setOpenId = function (openid) {
    if (this.sdk) this.sdk.setOpenId(openid)
}

DnSdkTool.prototype.setUnionId = function (unionid) {
    if (this.sdk) this.sdk.setUnionId(unionid)
}
DnSdkTool.prototype.isConformToSource = function () {
    let channel = UserManager.getInstance().getUserAdChannel()
    cc.log("DnSdk isConformToSource channel ", channel)
    if (channel == 2 || channel == 200) {
        return true
    }
    return false
}
DnSdkTool.prototype.getCreateDay = function (create_time) {
    if (!create_time) return 0
    let localTime = Localhost.timeInDay(Localhost.timeInSec())
    let createTime = Localhost.timeInDay(create_time)
    let offset = localTime - createTime
    cc.log("DnSdk getCreateDay offset ", offset)
    return offset

}
// 注册(包括回流)
DnSdkTool.prototype.onRegister = function (data) {
    cc.log("DnSdk onRegister ", data)
    if (!this.sdk) return
    this.data = data
    if (!this.data.is_new) {
        return
    }
    cc.log("DnSdk onRegister ok")
    this.sdk.onRegister()
}
DnSdkTool.prototype.getData = function () {
    return this.data || {}
}
// 创角-进入主场景
DnSdkTool.prototype.onCreateRole = function () {
    if (!this.sdk) return

    if (!this.getData().is_new) return
    if (this.createTag) {
        cc.log("DnSdk onCreateRole this.createTag ", this.createTag)
        return
    }
    this.createTag = true
    cc.log("DnSdk onCreateRole ok")
    this.sdk.onCreateRole()
}
// 完成新手引导 （打完第一关）
DnSdkTool.prototype.onTutorialFinish = function (levelId) {
    if (!this.sdk) return
    cc.log("DnSdk onTutorialFinish levelId ", levelId)
    if (!levelId || levelId != 1) return
    let topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    cc.log("DnSdk onTutorialFinish topLevel ", topLevel)
    if (topLevel != 1 && topLevel != 2) return
    cc.log("DnSdk onTutorialFinish ok ", levelId)
    this.sdk.onTutorialFinish()
}
// 付费 value 付费金额单位分
DnSdkTool.prototype.onPurchase = function (value) {
    cc.log("DnSdk onPurchase value ", value)
    if (!this.sdk) return
    this.sdk.onPurchase(value)
}
DnSdkTool.prototype.track = function (key, data) {
    if (!this.sdk) return
    cc.log("DnSdk track key ", key, data)
    this.sdk.track(key, data)
}
//收藏小游戏(ADD_TO_WISHLIST)
DnSdkTool.prototype.onAddToWishlist = function () {
    if (!this.sdk) return
    cc.log("DnSdk onAddToWishlist ok ")
    // this.sdk.onAddToWishlist()
    this.sdk.track('ADD_TO_WISHLIST', {
        //  普通收藏（default）
        type: 'default',
    })
}


module.exports = DnSdkTool;